import styled from 'styled-components';

export const Block = styled.em`
  font-style: normal;
`;
